/* Iris Academia — Build Your Journal (7-step panel). Real Shopify variants are read from Liquid;
   the panel keeps steps 1–4 open as swatch grids, opens 5–7 as accordions, and adds to the real cart. */
(function () {
  var WALNUT = '#3B2417', BRONZE = '#A77742', LINEN = '#D8CABD', DEEP = '#2A160D', PARCH = '#F4F0E8';
  function esc(s) { return String(s == null ? '' : s).replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;').replace(/"/g, '&quot;'); }
  function fmtPrice(n) { return '€' + (n % 1 === 0 ? n : n.toFixed(2)); }
  function sizeKey(sub) { return /A5/.test(sub) ? 'A5' : (/A6/.test(sub) ? 'A6' : 'Passport'); }
  function pick(list, k) { return list.filter(function (o) { return o.k === k; })[0] || {}; }

  var LEATHER_DATA = [
    { k: 'ink', name: 'Ink Black', c: '#262425' },
    { k: 'walnut', name: 'Dark Walnut', c: '#43231B' },
    { k: 'burgundy', name: 'Burgundy Wine', c: '#5E282D' },
    { k: 'olive', name: 'Olive Grove', c: '#4B553A' },
    { k: 'navy', name: 'Midnight Navy', c: '#1A2E3E' },
    { k: 'waxred', name: 'Wax Seal Red', c: '#A82A24' },
  ];
  var CORD_DATA = [
    { k: 'ink', name: 'Black', c: '#151515' }, { k: 'walnut', name: 'Chocolate Brown', c: '#3E1F17' },
    { k: 'navy', name: 'Navy Blue', c: '#1B2A5C' }, { k: 'terracotta', name: 'Burgundy', c: '#5A0F1C' },
    { k: 'waxred', name: 'Red', c: '#C8161B' }, { k: 'linen', name: 'Cream', c: '#EDE6D3' },
    { k: 'olive', name: 'Olive Green', c: '#3F4424' },
  ];
  var HW_DATA = [
    { k: 'gold', name: 'Gold' }, { k: 'brass', name: 'Brass Gold' }, { k: 'silver', name: 'Silver' }, { k: 'gunmetal', name: 'Gunmetal' },
  ];
  var INSERT_DATA = [
    { k: 'dotted', name: 'Dotted' }, { k: 'lined', name: 'Lined' }, { k: 'grid', name: 'Grid' }, { k: 'blank', name: 'Blank' },
  ];
  var O = window.IrisOpts;
  var HOTFOIL_DATA = O.HOTFOIL, ENGRAVE_DATA = O.ENGRAVE, LACE_DATA = O.LACE;
  var PERSO_COST = { none: 0, engraving: 8, hotfoil: 12, stitching: 25, straight: 20 };
  var CHARM_COST = { none: 0, simple: 3, enamel: 5, locket: 7, handmade: 12 };
  var CHARM_NAME = { none: 'None', simple: 'Simple', enamel: 'Enamel', locket: 'Locket', handmade: 'Handmade' };
  var BM_FAM = { attached: 'Attached to the journal', standalone: 'Standalone' }, BM_MAT = { cord: 'Cord', metal: 'Metal' };
  var PERSO_NAME = { none: 'None', engraving: 'Engraving', hotfoil: 'Hot Foil', stitching: 'Cross Stitching', straight: 'Straight Stitching' };
  var PLACEMENT_NAME = O.PLACEMENT;
  /* Variant titles of the "Atelier Details" add-on product in Shopify, keyed by builder option. */
  var ADDON_TITLE = {
    perso: { engraving: 'Engraving', hotfoil: 'Hot Foil Embossing', stitching: 'Hand Stitching', straight: 'Straight Stitching' },
    charm: { simple: 'Simple Charm', enamel: 'Enamel Charm', locket: 'Locket Charm', handmade: 'Handmade Iris Academia Charm' },
  };
  var STEPS = [
    { n: 1, k: 'leather', label: 'Leather', title: 'Choose your leather colour', sub: 'Included in base price. Press and hold a colour to see it larger.' },
    { n: 2, k: 'cord', label: 'Cord', title: 'Choose your closure cord', sub: 'Included in base price.' },
    { n: 3, k: 'hardware', label: 'Hardware', title: 'Choose your hardware finish', sub: 'Included in base price.' },
    { n: 4, k: 'inserts', label: 'Inserts', title: 'Choose your inserts', sub: '' },
    { n: 5, k: 'perso', label: 'Personalise', title: 'Personalisation', sub: 'Add a personal touch.' },
    { n: 6, k: 'keepsakes', label: 'Keepsakes', title: 'Keepsake Details', sub: 'Add meaningful details.' },
    { n: 7, k: 'review', label: 'Review', title: 'Review Your Journal', sub: 'See your final selections and price.' },
  ];

  /* ---------- small style helpers ---------- */
  function tileStyle(on) {
    return 'display:flex;flex-direction:column;align-items:center;gap:7px;padding:0;background:none;border:none;cursor:pointer;font-family:inherit;color:#3B2417;';
  }
  function tileImg(on, url, ratio, extra) {
    return '<span style="display:block;width:100%;aspect-ratio:' + ratio + ';background:#E7DCCF url(\'' + esc(url) + '\') center / cover no-repeat;border-radius:2px;box-sizing:border-box;' +
      (on ? 'outline:2px solid ' + DEEP + ';outline-offset:2px;' : 'outline:1px solid ' + LINEN + ';outline-offset:2px;') + (extra || '') + '"></span>';
  }
  function tileLabel(on, text) {
    return '<span style="font-size:11.5px;line-height:1.25;text-align:center;color:' + (on ? DEEP : '#6f5d48') + ';' + (on ? 'font-weight:600;' : '') + '">' + esc(text) + '</span>';
  }
  function radioRow(on) {
    return 'display:flex;align-items:center;gap:12px;width:100%;padding:13px 15px;cursor:pointer;background:#F4F0E8;font-family:inherit;transition:all .18s;margin-bottom:8px;text-align:left;' +
      (on ? 'border:1.5px solid ' + WALNUT + ';background:#E7DCCF;' : 'border:1px solid ' + LINEN + ';');
  }
  function dotStyle(on) {
    return 'width:15px;height:15px;border-radius:50%;flex-shrink:0;border:1.5px solid ' + (on ? BRONZE : '#B7A98C') + ';background:' + (on ? BRONZE : 'transparent') + ';box-shadow:' + (on ? 'inset 0 0 0 3px #F4F0E8' : 'none') + ';';
  }
  function pillStyle(on) {
    return 'padding:9px 14px;cursor:pointer;background:#F4F0E8;font-family:inherit;font-size:12.5px;letter-spacing:0.04em;transition:all .18s;' +
      (on ? 'border:1.5px solid ' + BRONZE + ';color:' + WALNUT + ';background:#E7DCCF;' : 'border:1px solid ' + LINEN + ';color:#6f5d48;');
  }
  function sectionTitle(n, title, sub) {
    return '<h3 style="font-family:\'Cormorant\',serif;font-weight:600;font-size:18px;margin:0;color:' + DEEP + ';">' + n + '. ' + esc(title) + '</h3>' +
      (sub ? '<p style="font-size:13px;color:#8a7a64;margin:4px 0 0;">' + esc(sub) + '</p>' : '');
  }
  function changeCard(label, value, btnAttr) {
    return '<div style="display:flex;align-items:center;justify-content:space-between;gap:12px;background:#F4F0E8;border:1px solid ' + LINEN + ';padding:12px 14px;">' +
      '<span style="font-size:14px;color:#3B2417;">' + esc(value) + '</span>' +
      '<button type="button" ' + btnAttr + ' style="background:#EFE6DA;border:1px solid #C9BCA4;cursor:pointer;font-family:inherit;font-size:11.5px;letter-spacing:0.12em;text-transform:uppercase;padding:7px 12px;color:#3B2417;">Change</button></div>';
  }

  function IrisJournalBuilder(root) {
    this.root = root;
    var cfg = JSON.parse(root.querySelector('[data-ia-jb-config]').textContent);
    this.cfg = cfg;
    var sw = {};
    try { var swEl = root.querySelector('[data-ia-jb-swatches]'); sw = swEl ? JSON.parse(swEl.textContent) : {}; } catch (e) { sw = {}; }
    this.sw = sw;

    var shop = null;
    try { var shopEl = root.querySelector('[data-ia-jb-variants]'); shop = shopEl ? JSON.parse(shopEl.textContent) : null; } catch (e) { shop = null; }
    this.shop = shop;
    if (shop) {
      Object.keys(cfg.products).forEach(function (k) {
        var J = shop.journals && shop.journals[k];
        if (J && J.variants && J.variants.length) cfg.products[k].base = Math.min.apply(null, J.variants.map(function (v) { return v.price; })) / 100;
        var r = (shop.refills || []).filter(function (x) { return x.size === sizeKey(cfg.products[k].sub); })[0];
        if (r) cfg.products[k].refill = r.price / 100;
      });
      var addonPrice = {};
      (shop.addons || []).forEach(function (a) { addonPrice[a.title] = a.price / 100; });
      function override(costMap, titleMap) { Object.keys(titleMap).forEach(function (k) { if (addonPrice[titleMap[k]] != null) costMap[k] = addonPrice[titleMap[k]]; }); }
      override(PERSO_COST, ADDON_TITLE.perso); override(CHARM_COST, ADDON_TITLE.charm);
      this.addonPrice = addonPrice;
    }
    this.addonPrice = this.addonPrice || {};
    var ex = { bookmarks: [], kd: {} };
    try { var exEl = root.querySelector('[data-ia-extras]'); if (exEl) ex = JSON.parse(exEl.textContent); } catch (e) {}
    this.extras = ex;

    var urlProduct = null;
    try { urlProduct = new URLSearchParams(window.location.search).get('product'); } catch (e) {}
    var keys = Object.keys(cfg.products);
    this.state = {
      product: (urlProduct && cfg.products[urlProduct]) ? urlProduct : (cfg.defaultProduct || keys[0]),
      leather: 'walnut', cord: 'walnut', hardware: 'gold', inserts: ['lined'], refills: 0,
      perso: 'none', foil: 'gold', engrave: 'natural', thread: 'ecru', placement: O.DEFAULT_PLACEMENT, persoText: '',
      lace: 'none', laceMode: 'none', charm: 'none', charmFamily: 'romantic', bookmark: 'none', bmMat: null, bmId: null,
      galIdx: 0, step: 1, open: { 5: false, 6: false, 7: false }, modal: null, added: false,
    };
    this.busy = false;

    var self = this;
    var backdrop = root.querySelector('[data-ia-jb-modal-backdrop]');
    root.querySelector('[data-ia-jb-modal-close]').addEventListener('click', function () { self.closeModal(); });
    root.querySelector('[data-ia-jb-modal-done]').addEventListener('click', function () { self.closeModal(); });
    backdrop.addEventListener('click', function (e) { if (e.target === backdrop) self.closeModal(); });

    var primary = root.querySelector('[data-ia-jb-cart]');
    primary.addEventListener('click', function () {
      if (self.state.step < 7) { self.goStep(self.state.step + 1, true); return; }
      if (self.state.added) { window.location.href = window.IrisCart ? window.IrisCart.cartUrl() : '/cart'; return; }
      if (self.busy) return;
      var items;
      try { items = self.buildCartItems(); } catch (err) { self.showError(err.message); return; }
      self.busy = true; primary.disabled = true; primary.textContent = 'Adding…';
      window.IrisCart.add(items).then(function () { self.busy = false; primary.disabled = false; self.state.added = true; self.render(); })
        .catch(function (err) { self.busy = false; primary.disabled = false; self.render(); self.showError(err.message); });
    });
    var back = root.querySelector('[data-ia-jb-back]');
    if (back) back.addEventListener('click', function () { if (self.state.step > 1) self.goStep(self.state.step - 1, true); });

    this.render();
  }

  IrisJournalBuilder.prototype.set = function (k, v) {
    this.state[k] = v; this.state.added = false;
    if (k === 'leather') this.state.leatherPreview = true;   // main photo shows the chosen leather
    if (k === 'galIdx') this.state.leatherPreview = false;   // until a gallery thumb is chosen
    if (k === 'product') { var mx = this.cfg.products[v].inserts || 1; if (this.state.inserts.length > mx) this.state.inserts = this.state.inserts.slice(0, mx); }
    this.render();
  };
  IrisJournalBuilder.prototype.goStep = function (n, scroll) {
    n = Math.max(1, Math.min(7, n));
    this.state.step = n;
    if (n >= 5) this.state.open[n] = true;
    this.render();
    if (scroll) {
      var target = this.root.querySelector('[data-ia-jb-section="' + n + '"]');
      if (target) { try { target.scrollIntoView({ behavior: 'smooth', block: 'start' }); } catch (e) { target.scrollIntoView(); } }
    }
  };
  IrisJournalBuilder.prototype.computeTotal = function () {
    var s = this.state, P = this.cfg.products[s.product];
    return P.base + PERSO_COST[s.perso] + this.laceCost() + CHARM_COST[s.charm] + this.bmCost() + s.refills * P.refill;
  };
  IrisJournalBuilder.prototype.laceCost = function () {
    var o = O.pick(LACE_DATA, this.state.lace); return o.addon ? (this.addonPrice[o.addon] != null ? this.addonPrice[o.addon] : 12) : 0;
  };
  IrisJournalBuilder.prototype.bmItem = function () {
    var id = this.state.bmId; if (!id || this.state.bookmark === 'none') return null;
    return (this.extras.bookmarks || []).filter(function (b) { return b.id === id; })[0] || null;
  };
  IrisJournalBuilder.prototype.laceCostOf = function (k) {
    var o = O.pick(LACE_DATA, k); return o.addon ? (this.addonPrice[o.addon] != null ? this.addonPrice[o.addon] : 12) : 0;
  };
  IrisJournalBuilder.prototype.bmList = function (fam, mat) {
    return (this.extras.bookmarks || []).filter(function (b) { return b.fam === fam && (!mat || b.mat === mat); });
  };
  IrisJournalBuilder.prototype.bmFrom = function (fam) {
    var l = fam ? this.bmList(fam) : (this.extras.bookmarks || []);
    return l.length ? Math.min.apply(null, l.map(function (b) { return b.price; })) / 100 : 0;
  };
  IrisJournalBuilder.prototype.openPerso = function () {
    var self = this, s = this.state, O2 = O;
    O2.perso({
      state: s, isLegacy: !!this.cfg.isLegacy, leatherImg: (this.sw.leather || {})[s.leather], leatherTex: (this.sw.tex || {})[s.leather], finishImgs: this.extras.eng, placeImgs: this.extras.pl, leatherColor: pick(LEATHER_DATA, s.leather).c,
      prices: { hotfoil: PERSO_COST.hotfoil, engraving: PERSO_COST.engraving, stitching: PERSO_COST.stitching, straight: PERSO_COST.straight }, money: fmtPrice,
      onChange: function () { s.added = false; }, onClose: function () { self.render(); },
    });
  };
  IrisJournalBuilder.prototype.openLace = function () {
    var self = this, s = this.state, kd = this.extras.kd || {};
    O.picker({
      title: 'Lace & Doily', sub: 'Choose the detail that makes your journal unmistakably yours.', selected: s.lace, cols: 3, ratio: '1/1',
      items: LACE_DATA.map(function (o) { return { k: o.k, name: o.name, sub: o.kind + ' · ' + o.where, desc: o.desc, img: kd[o.k], price: '+' + fmtPrice(self.laceCostOf(o.k)) }; }),
      note: 'Every lace and doily is hand-applied, so the pattern may vary slightly.', doneLabel: 'Confirm detail',
      onPick: function (k) { s.lace = k; s.laceMode = 'lace'; s.added = false; }, onClose: function () { self.render(); },
    });
  };
  IrisJournalBuilder.prototype.openBookmarks = function (fam, mat) {
    var self = this, s = this.state;
    O.picker({
      title: (fam === 'attached' ? 'Attached' : 'Standalone') + ' bookmarks · ' + BM_MAT[mat], sub: fam === 'attached' ? 'Fixed to your journal, so it is always where you left off.' : 'A loose keepsake bookmark to slip between any pages.',
      selected: s.bmId, cols: 3, ratio: '334/396', empty: 'New ' + BM_MAT[mat].toLowerCase() + ' bookmarks are on their way.',
      items: this.bmList(fam, mat).map(function (b) { return { k: b.id, name: b.title, sub: b.variant, img: b.img, price: '+' + fmtPrice(b.price / 100), disabled: b.available === false }; }),
      doneLabel: 'Confirm bookmark',
      onPick: function (id) { s.bmId = id; s.bookmark = fam; s.bmMat = mat; s.added = false; }, onClose: function () { self.render(); },
    });
  };
  IrisJournalBuilder.prototype.bmCost = function () { var b = this.bmItem(); return b ? b.price / 100 : 0; };
  IrisJournalBuilder.prototype.bmName = function (b) { return b ? b.title + (b.variant ? ' — ' + b.variant : '') : ''; };
  IrisJournalBuilder.prototype.extrasCount = function () {
    var s = this.state;
    return (PERSO_COST[s.perso] ? 1 : 0) + (this.laceCost() ? 1 : 0) + (CHARM_COST[s.charm] ? 1 : 0) + (this.bmCost() ? 1 : 0) + (s.refills > 0 ? 1 : 0);
  };
  IrisJournalBuilder.prototype.names = function () {
    var s = this.state;
    var fo = pick(HOTFOIL_DATA, s.foil);
    var finish = s.perso === 'hotfoil' ? fo.name : (s.perso === 'engraving' ? pick(ENGRAVE_DATA, s.engrave).name : (O.isStitch(s.perso) ? pick(O.THREAD, s.thread).name + ' thread' : ''));
    return { leather: pick(LEATHER_DATA, s.leather).name, cord: pick(CORD_DATA, s.cord).name, hardware: pick(HW_DATA, s.hardware).name, insert: pick(INSERT_DATA, s.inserts[0]).name, inserts: O.insertLabel(s.inserts, this.cfg.products[s.product].inserts || 1, INSERT_DATA), finish: finish };
  };
  IrisJournalBuilder.prototype.persoLabel = function () {
    var s = this.state, n = this.names();
    if (s.perso === 'none') return 'None';
    return PERSO_NAME[s.perso] + (n.finish ? ' · ' + n.finish : '') + ' · ' + (O.isStitch(s.perso) ? 'Lower right' : (PLACEMENT_NAME[s.placement] || s.placement)) + (s.persoText ? ' · "' + s.persoText + '"' : '');
  };

  /* ---------- render ---------- */
  IrisJournalBuilder.prototype.render = function () {
    var self = this, s = this.state, cfg = this.cfg, root = this.root, P = cfg.products[s.product];

    // stepper
    var stepper = root.querySelector('[data-ia-jb-stepper]');
    stepper.innerHTML = STEPS.map(function (st) {
      var cur = st.n === s.step, done = st.n < s.step;
      return '<button type="button" data-step="' + st.n + '"' + (cur ? ' data-current' : '') + ' style="background:none;border:none;padding:0;cursor:pointer;font-family:inherit;display:flex;flex-direction:column;align-items:center;gap:7px;flex:1;min-width:0;position:relative;">' +
        '<span style="width:26px;height:26px;border-radius:50%;display:flex;align-items:center;justify-content:center;font-size:12px;position:relative;z-index:1;' +
        (cur ? 'background:' + DEEP + ';color:' + PARCH + ';border:1px solid ' + DEEP + ';' : (done ? 'background:#E7DCCF;color:' + DEEP + ';border:1px solid ' + WALNUT + ';' : 'background:' + PARCH + ';color:#6f5d48;border:1px solid #C9BCA4;')) + '">' + st.n + '</span>' +
        '<span style="font-size:8.5px;letter-spacing:0.08em;text-transform:uppercase;color:' + (cur ? DEEP : '#8a7a64') + ';white-space:nowrap;max-width:100%;overflow:hidden;text-overflow:ellipsis;">' + esc(st.label) + '</span></button>';
    }).join('');
    stepper.querySelectorAll('button').forEach(function (b) { b.addEventListener('click', function () { self.goStep(parseInt(b.dataset.step, 10), true); }); });

    // product cards
    var prodEl = root.querySelector('[data-ia-jb-products]');
    prodEl.innerHTML = '';
    Object.keys(cfg.products).forEach(function (k) {
      var p = cfg.products[k], on = s.product === k;
      var btn = document.createElement('button');
      btn.type = 'button';
      btn.style.cssText = 'display:flex;flex-direction:column;align-items:center;justify-content:center;padding:10px 6px;cursor:pointer;background:#F4F0E8;transition:all .18s;font-family:inherit;text-align:center;' +
        (on ? 'border:1.5px solid ' + WALNUT + ';box-shadow:0 3px 14px rgba(58,36,23,0.14);' : 'border:1px solid ' + LINEN + ';');
      btn.innerHTML = '<span style="font-family:\'Cormorant\',serif;font-size:18px;color:' + DEEP + ';">' + esc(p.name) + '</span><span style="font-size:10.5px;letter-spacing:0.1em;text-transform:uppercase;color:#8a7a64;margin-top:2px;">' + esc(p.sub) + '</span><span style="font-family:\'Cormorant\',serif;font-size:14px;color:' + BRONZE + ';margin-top:3px;">' + fmtPrice(p.base) + '</span>';
      btn.addEventListener('click', function () { self.set('product', k); });
      prodEl.appendChild(btn);
    });

    // sections
    var body = root.querySelector('[data-ia-jb-body]');
    body.innerHTML = '';
    STEPS.forEach(function (st) { body.appendChild(self.renderSection(st)); });

    // footer
    var extras = this.extrasCount(), total = this.computeTotal();
    root.querySelector('[data-ia-jb-total-label]').textContent = extras ? 'Total' : 'Base price';
    root.querySelectorAll('[data-ia-jb-price]').forEach(function (el) { el.textContent = fmtPrice(total); });
    var primary = root.querySelector('[data-ia-jb-cart]');
    if (s.step < 7) { primary.textContent = 'Next step'; primary.style.background = DEEP; }
    else { primary.textContent = s.added ? '✓ Added · View cart →' : 'Add to cart'; primary.style.background = s.added ? BRONZE : DEEP; }
    var back = root.querySelector('[data-ia-jb-back]');
    if (back) back.style.visibility = s.step > 1 ? 'visible' : 'hidden';

    // gallery: a journal with its own photo ("img") shows it first, in place of the shared main photo
    var gallery = cfg.gallery.slice();
    if (P.img) {
      gallery = [gallery[0]].concat(gallery.slice(1).filter(function (g) { return g.src !== P.img; }));
      gallery[0] = { src: P.img, label: P.name, cap: P.cap || P.name };
    }
    var galEl = root.querySelector('[data-ia-jb-gallery-thumbs]');
    galEl.innerHTML = '';
    gallery.forEach(function (g, i) {
      var btn = document.createElement('button');
      btn.type = 'button'; btn.setAttribute('aria-label', g.label);
      var on = s.galIdx === i;
      btn.style.cssText = "width:84px;height:84px;background:url('" + g.src + "') center / cover no-repeat;cursor:pointer;border:none;padding:0;transition:all .18s;" + (on ? 'outline:1.5px solid ' + WALNUT + ';outline-offset:2px;' : 'outline:1px solid #E2D8C6;');
      btn.addEventListener('click', function () { self.set('galIdx', i); });
      galEl.appendChild(btn);
    });
    var cur = gallery[s.galIdx] || gallery[0];
    var leatherImg = (this.sw.leather || {})[s.leather];
    if (s.leatherPreview && leatherImg) {
      root.querySelector('[data-ia-jb-main-img]').style.backgroundImage = "url('" + leatherImg + "')";
      root.querySelector('[data-ia-jb-gal-caption]').textContent = pick(LEATHER_DATA, s.leather).name + ' leather';
      galEl.querySelectorAll('button').forEach(function (b) { b.style.outline = '1px solid #E2D8C6'; b.style.outlineOffset = '0'; });
    } else {
      root.querySelector('[data-ia-jb-main-img]').style.backgroundImage = "url('" + cur.src + "')";
      root.querySelector('[data-ia-jb-gal-caption]').textContent = cur.cap;
    }

    this.renderModal();
  };

  IrisJournalBuilder.prototype.renderSection = function (st) {
    var self = this, s = this.state, sw = this.sw, P = this.cfg.products[s.product];
    var wrap = document.createElement('section');
    wrap.setAttribute('data-ia-jb-section', st.n);
    var isAccordion = st.n >= 5;
    var open = !isAccordion || s.open[st.n];
    wrap.style.cssText = 'padding:' + (isAccordion ? '16px 0' : '22px 0') + ';border-bottom:1px solid #E2D8C6;' + (st.n === s.step ? '' : '');

    if (isAccordion) {
      var from = st.n === 5 ? 'From +' + fmtPrice(Math.min(PERSO_COST.engraving, PERSO_COST.hotfoil, PERSO_COST.stitching, PERSO_COST.straight)) : (st.n === 6 ? 'From +' + fmtPrice(Math.min(CHARM_COST.simple, this.laceCostOf('lace-ivory'), this.bmFrom())) : '');
      var head = document.createElement('button');
      head.type = 'button';
      head.style.cssText = 'width:100%;display:flex;align-items:center;gap:14px;background:none;border:none;padding:4px 0;cursor:pointer;font-family:inherit;text-align:left;';
      head.innerHTML = '<span style="font-size:14px;color:' + DEEP + ';min-width:16px;">' + st.n + '.</span>' +
        '<span style="flex:1;min-width:0;"><span style="display:block;font-family:\'Cormorant\',serif;font-weight:600;font-size:17px;color:' + DEEP + ';">' + esc(st.title) + '</span><span style="display:block;font-size:12.5px;color:#8a7a64;margin-top:2px;">' + esc(st.sub) + '</span></span>' +
        (from ? '<span style="font-size:12px;color:#5a4636;white-space:nowrap;">' + esc(from) + '</span>' : '') +
        '<span style="font-size:16px;color:' + BRONZE + ';transform:rotate(' + (open ? '180deg' : '0') + ');transition:transform .2s;">&#8964;</span>';
      head.addEventListener('click', function () {
        if (s.open[st.n] && s.step === st.n) { s.open[st.n] = false; self.render(); }
        else self.goStep(st.n, false);
      });
      wrap.appendChild(head);
      if (!open) return wrap;
      var inner = document.createElement('div');
      inner.style.cssText = 'padding:14px 0 6px 30px;animation:ia-fade .25s ease;';
      inner.innerHTML = this.stepHTML(st);
      wrap.appendChild(inner);
      this.bindStep(st, inner);
      return wrap;
    }

    var titleEl = document.createElement('div');
    titleEl.innerHTML = sectionTitle(st.n, st.title, st.n === 4 ? 'Included in base price. ' + P.sub.split(' ')[0] + ' includes ' + P.inserts + ' insert' + (P.inserts > 1 ? 's' : '') + (P.inserts > 1 ? ' — choose up to ' + P.inserts + ' paper styles.' : '.') : st.sub);
    wrap.appendChild(titleEl);
    var content = document.createElement('div');
    content.style.cssText = 'margin-top:14px;';
    content.innerHTML = this.stepHTML(st);
    wrap.appendChild(content);
    this.bindStep(st, content);
    return wrap;
  };

  IrisJournalBuilder.prototype.stepHTML = function (st) {
    var s = this.state, sw = this.sw, cfg = this.cfg, P = cfg.products[s.product], n = this.names();
    var self = this;
    function grid(cols, items) { return '<div style="display:grid;grid-template-columns:repeat(' + cols + ',minmax(0,1fr));gap:10px 8px;">' + items.join('') + '</div>'; }

    if (st.k === 'leather') {
      return grid(6, LEATHER_DATA.map(function (o) {
        var on = s.leather === o.k;
        // press and hold shows the real leather hide larger (iris-zoom.js)
        return '<button type="button" data-pick="leather" data-k="' + o.k + '" data-ia-zoom="' + esc((sw.real || {})[o.k] || (sw.leather || {})[o.k] || '') + '" data-ia-zoom-label="' + esc(o.name) + '" style="' + tileStyle(on) + '">' + tileImg(on, (sw.leather || {})[o.k] || '', '3/4.2', on ? '' : '') + tileLabel(on, o.name) + '</button>';
      }));
    }
    if (st.k === 'cord') {
      return grid(7, CORD_DATA.map(function (o) {
        var on = s.cord === o.k;
        return '<button type="button" data-pick="cord" data-k="' + o.k + '" style="' + tileStyle(on) + '">' + tileImg(on, (sw.cord || {})[o.k] || '', '9/10') + tileLabel(on, o.name) + '</button>';
      }));
    }
    if (st.k === 'hardware') {
      return grid(4, HW_DATA.map(function (o) {
        var on = s.hardware === o.k;
        return '<button type="button" data-pick="hardware" data-k="' + o.k + '" style="' + tileStyle(on) + '">' + tileImg(on, (sw.hw || {})[o.k] || '', '3/4') + tileLabel(on, o.name) + '</button>';
      }));
    }
    if (st.k === 'inserts') {
      var maxIns = P.inserts || 1;
      return grid(4, INSERT_DATA.map(function (o) {
        var idx = s.inserts.indexOf(o.k), on = idx >= 0;
        return '<button type="button" data-insert="' + o.k + '" aria-pressed="' + on + '" style="' + tileStyle(on) + 'position:relative;">' + tileImg(on, (sw.insert || {})[o.k] || '', '1/1') +
          (on && maxIns > 1 ? '<span style="position:absolute;top:6px;right:6px;width:20px;height:20px;border-radius:50%;background:' + DEEP + ';color:#F4F0E8;font-size:11px;line-height:20px;text-align:center;">' + (idx + 1) + '</span>' : '') + tileLabel(on, o.name) + '</button>';
      })) +
        '<p style="font-size:13px;color:#5a4636;margin:12px 0 0;"><strong style="font-weight:600;">Your ' + maxIns + ' insert' + (maxIns > 1 ? 's' : '') + ':</strong> ' + esc(n.inserts) + '</p>' +
        (maxIns > 1 ? '<p style="font-size:12px;color:#8a7a64;margin:4px 0 0;">Tap a style to add or remove it. Your inserts are shared between the styles you choose.</p>' : '') +
        '<div style="background:#F4F0E8;border:1px solid ' + LINEN + ';padding:12px 16px;font-size:13.5px;line-height:1.55;color:#5a4636;margin:16px 0 0;">All inserts are made with fountain pen friendly paper, chosen for a smooth and elegant writing experience.</div>' +
        '<a href="' + (window.Shopify&&Shopify.routes&&Shopify.routes.root||'/') + 'pages/refill-notebooks" style="display:flex;align-items:center;justify-content:space-between;gap:12px;background:#F4F0E8;border:1px solid ' + LINEN + ';padding:12px 16px;margin-top:10px;text-decoration:none;color:#3B2417;">' +
        '<span style="font-size:14px;">Need more inserts? <span style="color:#8a7a64;">Browse all refill inserts</span></span><span style="font-size:12px;letter-spacing:0.14em;text-transform:uppercase;color:' + BRONZE + ';white-space:nowrap;">Shop refills &rarr;</span></a>';
    }
    if (st.k === 'perso') {
      var opts = [
        { k: 'none', label: 'No personalisation' },
        { k: 'hotfoil', label: 'Hot Foil Embossing', price: '+' + fmtPrice(PERSO_COST.hotfoil) },
        { k: 'engraving', label: 'Engraving', price: '+' + fmtPrice(PERSO_COST.engraving) },
        { k: 'stitching', label: 'Cross Stitching', price: '+' + fmtPrice(PERSO_COST.stitching) },
        { k: 'straight', label: 'Straight Stitching', price: '+' + fmtPrice(PERSO_COST.straight) },
      ];
      var html = opts.map(function (o) {
        var on = s.perso === o.k;
        return '<button type="button" data-perso="' + o.k + '" style="' + radioRow(on) + '"><span style="' + dotStyle(on) + '"></span><span style="flex:1;font-size:15px;color:#3B2417;">' + esc(o.label) + '</span><span style="font-size:13.5px;color:' + BRONZE + ';">' + (o.price || '') + '</span></button>';
      }).join('');
      if (s.perso === 'none') return html;
      html += '<div style="display:grid;grid-template-columns:minmax(0,1fr) auto;gap:10px;align-items:center;background:#F4F0E8;border:1px solid ' + LINEN + ';padding:12px 14px;margin-top:4px;">' +
        '<span style="font-size:13.5px;line-height:1.5;color:#3B2417;">' + esc(this.persoLabel()) + (s.persoText ? '' : ' <em style="color:#8B3A2F;">· add your text</em>') + '</span>' +
        '<button type="button" data-perso-edit style="background:#EFE6DA;border:1px solid #C9BCA4;cursor:pointer;font-family:inherit;font-size:11.5px;letter-spacing:0.12em;text-transform:uppercase;padding:8px 12px;color:#3B2417;">Preview &amp; edit</button></div>';
      html += '<p style="font-size:12px;font-style:italic;color:#8a7a64;margin:10px 0 0;">Personalisation placement may vary slightly due to the handmade nature of each piece.</p>';
      return html;
    }
    if (st.k === 'keepsakes') {
      function row(attr, on, label, price, extra) {
        return '<button type="button" ' + attr + ' style="' + radioRow(on) + '"><span style="' + dotStyle(on) + '"></span><span style="flex:1;font-size:14.5px;color:#3B2417;">' + esc(label) + '</span><span style="font-size:13px;color:' + BRONZE + ';">' + (price || '') + '</span></button>' + (extra || '');
      }
      function chosenCard(img, title, sub, price, btnAttr) {
        return '<div style="display:grid;grid-template-columns:64px minmax(0,1fr) auto;gap:12px;align-items:center;background:#F4F0E8;border:1px solid ' + LINEN + ';padding:10px 12px;margin:0 0 10px;">' +
          '<span style="width:64px;height:64px;background:#E7DCCF url(\'' + esc(img) + '\') center / cover no-repeat;"></span>' +
          '<span><span style="display:block;font-family:\'Cormorant\',serif;font-size:16px;color:' + DEEP + ';">' + esc(title) + '</span><span style="display:block;font-size:12px;color:#8a7a64;">' + esc(sub) + (price ? ' · <span style="color:' + BRONZE + ';">+' + esc(price) + '</span>' : '') + '</span></span>' +
          '<button type="button" ' + btnAttr + ' style="background:#EFE6DA;border:1px solid #C9BCA4;cursor:pointer;font-family:inherit;font-size:11.5px;letter-spacing:0.12em;text-transform:uppercase;padding:7px 12px;color:#3B2417;">Change</button></div>';
      }
      var head = function (t) { return '<p style="font-size:13px;font-weight:600;color:' + DEEP + ';margin:0 0 8px;">' + esc(t) + '</p>'; };
      // details: nothing / lace & doily
      var lace = O.pick(LACE_DATA, s.lace);
      var html = head('Keepsake details') +
        row('data-lace-mode="none"', s.laceMode === 'none', 'Nothing') +
        row('data-lace-mode="lace"', s.laceMode === 'lace', 'Lace / Doily', 'From +' + fmtPrice(this.laceCostOf('lace-ivory')));
      if (s.laceMode === 'lace') html += lace.k ? chosenCard((this.extras.kd || {})[lace.k], lace.name, lace.where, fmtPrice(this.laceCost()), 'data-open-lace') :
        '<button type="button" data-open-lace style="' + pillStyle(false) + 'margin:0 0 10px;">Choose lace or doily &rarr;</button>';
      // charm (unchanged)
      html += '<div style="height:10px;"></div>' + head('Keepsake charm') + [
        { k: 'none', label: 'No charm' }, { k: 'simple', label: 'Simple charm', price: '+' + fmtPrice(CHARM_COST.simple) },
        { k: 'enamel', label: 'Enamel / symbolic charm', price: '+' + fmtPrice(CHARM_COST.enamel) }, { k: 'locket', label: 'Locket / premium charm', price: '+' + fmtPrice(CHARM_COST.locket) },
        { k: 'handmade', label: 'Handmade Iris Academia charm', price: '+' + fmtPrice(CHARM_COST.handmade) },
      ].map(function (o) { return row('data-pick="charm" data-k="' + o.k + '"', s.charm === o.k, o.label, o.price); }).join('');
      if (s.charm !== 'none') {
        html += '<div style="margin:4px 0 14px;"><p style="font-size:11px;letter-spacing:0.16em;text-transform:uppercase;color:#5a4636;margin:0 0 8px;">Charm family</p><div style="display:flex;flex-wrap:wrap;gap:8px;">' +
          ['Romantic', 'Botanical', 'Symbolic', 'Celestial', 'Whimsical'].map(function (f) { var on = s.charmFamily === f.toLowerCase(); return '<button type="button" data-pick="charmFamily" data-k="' + f.toLowerCase() + '" style="' + pillStyle(on) + '">' + f + '</button>'; }).join('') + '</div></div>';
      }
      // bookmark: no / attached / standalone → cord / metal → pop-up
      var self2 = this, bm = this.bmItem();
      html += '<div style="height:10px;"></div>' + head('Keepsake bookmark') +
        row('data-bm-fam="none"', s.bookmark === 'none', 'No bookmark') +
        ['attached', 'standalone'].map(function (f) {
          var on = s.bookmark === f, from = self2.bmFrom(f);
          var sub = '';
          if (on) {
            sub = '<div style="display:flex;flex-wrap:wrap;gap:8px;margin:-2px 0 10px 27px;">' + ['cord', 'metal'].map(function (m) {
              var mon = s.bmMat === m, count = self2.bmList(f, m).length;
              return '<button type="button" data-bm-mat="' + m + '" style="' + pillStyle(mon) + '">' + BM_MAT[m] + ' <span style="color:#8a7a64;">(' + count + ')</span> &rarr;</button>';
            }).join('') + '</div>';
            if (bm && bm.fam === f) sub += chosenCard(bm.img, self2.bmName(bm), BM_FAM[f] + ' · ' + BM_MAT[bm.mat], fmtPrice(bm.price / 100), 'data-bm-mat="' + bm.mat + '"');
          }
          return row('data-bm-fam="' + f + '"', on, BM_FAM[f], from ? 'From +' + fmtPrice(from) : '', sub);
        }).join('');
      return html;
    }
    if (st.k === 'review') {
      var lz = O.pick(LACE_DATA, s.lace), bmi = this.bmItem();
      var rows = [
        ['Journal', P.name + ' — ' + P.sub, fmtPrice(P.base)],
        ['Leather colour', n.leather, 'Included'], ['Closure cord', n.cord, 'Included'], ['Hardware finish', n.hardware, 'Included'],
        ['Inserts', n.inserts, 'Included'],
        ['Personalisation', this.persoLabel(), s.perso === 'none' ? '—' : '+' + fmtPrice(PERSO_COST[s.perso])],
        ['Lace & doily', lz.k ? lz.name + ' · ' + lz.where : 'None', lz.k ? '+' + fmtPrice(this.laceCost()) : '—'],
        ['Keepsake charm', s.charm === 'none' ? 'None' : CHARM_NAME[s.charm] + ' · ' + s.charmFamily.charAt(0).toUpperCase() + s.charmFamily.slice(1), s.charm === 'none' ? '—' : '+' + fmtPrice(CHARM_COST[s.charm])],
        ['Keepsake bookmark', bmi ? this.bmName(bmi) + ' · ' + BM_FAM[bmi.fam] + ', ' + BM_MAT[bmi.mat].toLowerCase() : 'None', bmi ? '+' + fmtPrice(bmi.price / 100) : '—'],
      ];
      if (s.refills > 0) rows.push(['Extra refills', s.refills + ' × ' + n.insert, '+' + fmtPrice(s.refills * P.refill)]);
      return '<div style="border-top:1px solid #E2D8C6;">' + rows.map(function (r, i) {
        var stepFor = i === 0 ? 0 : (i <= 3 ? i : (i === 4 ? 4 : (i === 5 ? 5 : 6)));
        return '<div style="display:grid;grid-template-columns:110px minmax(0,1fr) auto;gap:10px;align-items:baseline;padding:9px 0;border-bottom:1px solid #E2D8C6;font-size:13.5px;">' +
          '<span style="font-size:10.5px;letter-spacing:0.14em;text-transform:uppercase;color:#8a7a64;">' + esc(r[0]) + '</span>' +
          '<span style="color:#3B2417;">' + esc(r[1]) + (stepFor ? ' <button type="button" data-goto="' + stepFor + '" style="background:none;border:none;padding:0 0 0 6px;cursor:pointer;font-family:inherit;font-size:11px;letter-spacing:0.1em;text-transform:uppercase;color:' + BRONZE + ';">Edit</button>' : '') + '</span>' +
          '<span style="font-family:\'Cormorant\',serif;font-size:15px;color:' + DEEP + ';white-space:nowrap;">' + esc(r[2]) + '</span></div>';
      }).join('') + '</div>' +
        '<div style="display:flex;align-items:center;gap:12px;margin:16px 0 0;background:#F4F0E8;border:1px solid #C9A875;padding:12px 14px;">' +
        '<img src="' + esc(sw.seal || '') + '" alt="" style="width:34px;height:auto;mix-blend-mode:multiply;' + (sw.seal ? '' : 'display:none;') + '">' +
        '<p style="font-size:13px;line-height:1.55;color:#5a4636;margin:0;">Dreaming of something more? <a href="' + (window.Shopify&&Shopify.routes&&Shopify.routes.root||'/') + 'pages/atelier-consultation" style="color:' + BRONZE + ';">Book a private Atelier Consultation</a>. The €25 fee may be deducted from your final order.</p></div>';
    }
    return '';
  };

  function placementPos(k) {
    if (/top/.test(k)) return 'top:8px;right:10px;';
    if (/center/.test(k)) return 'top:50%;right:10px;transform:translateY(-50%);';
    if (/bottom/.test(k) && !/front/.test(k)) return 'bottom:8px;right:10px;';
    return 'bottom:8px;right:10px;';
  }

  IrisJournalBuilder.prototype.bindStep = function (st, el) {
    var self = this, s = this.state;
    el.querySelectorAll('[data-pick]').forEach(function (b) { b.addEventListener('click', function () { self.set(b.dataset.pick, b.dataset.k); }); });
    el.querySelectorAll('[data-refill]').forEach(function (b) { b.addEventListener('click', function () { self.set('refills', Math.max(0, Math.min(9, s.refills + parseInt(b.dataset.refill, 10)))); }); });
    el.querySelectorAll('[data-insert]').forEach(function (b) { b.addEventListener('click', function () {
      self.set('inserts', O.toggleInsert(s.inserts, b.dataset.insert, self.cfg.products[s.product].inserts || 1));
    }); });
    el.querySelectorAll('[data-perso]').forEach(function (b) { b.addEventListener('click', function () {
      var k = b.dataset.perso; s.perso = k; s.added = false; self.render(); if (k !== 'none') self.openPerso();
    }); });
    el.querySelectorAll('[data-perso-edit]').forEach(function (b) { b.addEventListener('click', function () { self.openPerso(); }); });
    el.querySelectorAll('[data-lace-mode]').forEach(function (b) { b.addEventListener('click', function () {
      if (b.dataset.laceMode === 'none') { s.laceMode = 'none'; s.lace = 'none'; s.added = false; self.render(); }
      else { s.laceMode = 'lace'; self.render(); self.openLace(); }
    }); });
    el.querySelectorAll('[data-open-lace]').forEach(function (b) { b.addEventListener('click', function () { self.openLace(); }); });
    el.querySelectorAll('[data-bm-fam]').forEach(function (b) { b.addEventListener('click', function () {
      var f = b.dataset.bmFam; if (f === s.bookmark) return;
      s.bookmark = f; s.bmMat = null; s.bmId = null; s.added = false; self.render();
    }); });
    el.querySelectorAll('[data-bm-mat]').forEach(function (b) { b.addEventListener('click', function () { self.openBookmarks(s.bookmark, b.dataset.bmMat); }); });
    el.querySelectorAll('[data-open-modal]').forEach(function (b) { b.addEventListener('click', function () { self.openModal(b.dataset.openModal); }); });
    el.querySelectorAll('[data-goto]').forEach(function (b) { b.addEventListener('click', function () { self.goStep(parseInt(b.dataset.goto, 10), true); }); });
    var txt = el.querySelector('[data-perso-text]');
    if (txt) {
      txt.addEventListener('input', function (e) {
        s.persoText = e.target.value; s.added = false;
        var c = el.querySelector('[data-perso-count]'); if (c) c.textContent = s.persoText.length + ' / 25';
        var prev = el.querySelector('[data-perso-preview]'); if (prev) prev.textContent = s.persoText || 'Iris Academia';
      });
      txt.addEventListener('change', function () { self.render(); });
    }
  };

  /* ---------- modals: hot foil colour, engraving finish, placement ---------- */
  IrisJournalBuilder.prototype.openModal = function (g) { this.state.modal = g; this.render(); };
  IrisJournalBuilder.prototype.closeModal = function () { this.state.modal = null; this.render(); };
  IrisJournalBuilder.prototype.renderModal = function () {
    var self = this, s = this.state, root = this.root, cfg = this.cfg;
    var backdrop = root.querySelector('[data-ia-jb-modal-backdrop]');
    if (!s.modal) { backdrop.hidden = true; return; }
    backdrop.hidden = false;
    var titles = { foil: 'Hot Foil Colour', engrave: 'Engraving Finish', placement: 'Choose Placement' };
    var subs = { foil: 'Choose your foil colour for a warm, timeless finish.', engrave: 'Choose your engraving finish.', placement: 'Where should your personalisation sit?' };
    root.querySelector('[data-ia-jb-modal-title]').textContent = titles[s.modal] || '';
    var subEl = root.querySelector('[data-ia-jb-modal-subtitle]');
    subEl.hidden = false; subEl.textContent = subs[s.modal] || '';
    var done = root.querySelector('[data-ia-jb-modal-done]');
    done.textContent = s.modal === 'placement' ? 'Confirm placement' : 'Select this finish';
    var note = root.querySelector('[data-ia-jb-modal-note]');
    var body = root.querySelector('[data-ia-jb-modal-body]');
    body.innerHTML = '';
    var leatherC = pick(LEATHER_DATA, s.leather).c;
    var text = s.persoText || 'Iris Academia';

    if (s.modal === 'foil' || s.modal === 'engrave') {
      var data = s.modal === 'foil' ? HOTFOIL_DATA : ENGRAVE_DATA, key = s.modal === 'foil' ? 'foil' : 'engrave';
      var grid = document.createElement('div');
      grid.style.cssText = 'display:grid;grid-template-columns:repeat(3,minmax(0,1fr));gap:18px 14px;';
      data.forEach(function (o) {
        var on = s[key] === o.k;
        var b = document.createElement('button');
        b.type = 'button';
        b.style.cssText = 'background:none;border:none;padding:0;cursor:pointer;font-family:inherit;display:flex;flex-direction:column;align-items:center;gap:8px;';
        b.innerHTML = '<span style="display:flex;align-items:center;justify-content:center;width:100%;aspect-ratio:1/0.9;background:' + (o.tile || leatherC) + ';border-radius:3px;box-sizing:border-box;font-family:\'Cormorant\',serif;font-size:19px;line-height:1.1;text-align:center;padding:8px;color:' + o.c + ';' + (on ? 'outline:2px solid ' + DEEP + ';outline-offset:3px;' : 'outline:1px solid ' + LINEN + ';outline-offset:3px;') + '">' + esc(text) + '</span>' +
          '<span style="font-size:12px;color:' + (on ? DEEP : '#6f5d48') + ';' + (on ? 'font-weight:600;' : '') + '">' + esc(o.name) + '</span>';
        b.addEventListener('click', function () { self.set(key, o.k); });
        grid.appendChild(b);
      });
      body.appendChild(grid);
      if (note) { note.hidden = false; note.textContent = s.modal === 'foil' ? 'See how it looks on your journal.' : 'Engraving colour may vary slightly depending on the leather colour and texture.'; }
    } else if (s.modal === 'placement') {
      var ext = O.placements(!!cfg.isLegacy).map(function (k) { return { k: k, label: PLACEMENT_NAME[k] }; });
      function pills(label, list) {
        var w = document.createElement('div');
        w.innerHTML = '<p style="font-size:11.5px;letter-spacing:0.16em;text-transform:uppercase;color:#5a4636;margin:0 0 10px;">' + label + '</p>';
        var row = document.createElement('div'); row.style.cssText = 'display:flex;flex-wrap:wrap;gap:9px;margin-bottom:18px;';
        list.forEach(function (o) {
          var on = s.placement === o.k; var b = document.createElement('button'); b.type = 'button'; b.style.cssText = pillStyle(on); b.textContent = o.label;
          b.addEventListener('click', function () { self.set('placement', o.k); }); row.appendChild(b);
        });
        w.appendChild(row); return w;
      }
      body.appendChild(pills('Exterior placement', ext));
      if (note) { note.hidden = false; note.textContent = 'Placement may vary slightly due to the handmade nature of each piece.'; }
    }
  };

  /* ---------- cart ---------- */
  IrisJournalBuilder.prototype.showError = function (msg) {
    var btn = this.root.querySelector('[data-ia-jb-cart]');
    var note = btn.parentNode.querySelector('[data-ia-jb-error]');
    if (!note) { note = document.createElement('p'); note.setAttribute('data-ia-jb-error', ''); note.style.cssText = 'margin:12px 0 0;font-size:13.5px;font-style:italic;line-height:1.5;color:#8B3A2F;'; btn.parentNode.appendChild(note); }
    note.textContent = msg || 'Something went wrong. Please try again.';
    setTimeout(function () { if (note.parentNode) note.parentNode.removeChild(note); }, 7000);
  };

  IrisJournalBuilder.prototype.buildCartItems = function () {
    var s = this.state, P = this.cfg.products[s.product], shop = this.shop;
    if (!window.IrisCart) throw new Error('The cart is not available right now. Please refresh the page and try again.');
    if (!shop || !shop.journals) throw new Error('This journal cannot be ordered online yet. Please contact the atelier.');
    var n = this.names();
    var J = shop.journals[s.product];
    var variant = J && (J.variants || []).filter(function (v) { return v.leather === n.leather && v.hardware === n.hardware; })[0];
    if (!variant) throw new Error(n.leather + ' with ' + n.hardware + ' hardware is not available for ' + P.name + ' yet. Please choose another combination.');
    if (variant.available === false) throw new Error('This combination is currently sold out. Please choose another leather or hardware.');
    var forLabel = P.name + ' — ' + n.leather + ' / ' + n.hardware;
    var props = { 'Leather Colour': n.leather, 'Hardware Finish': n.hardware, 'Closure Cord Colour': n.cord, 'Inserts': n.inserts };
    var lz = O.pick(LACE_DATA, s.lace), bmi = this.bmItem();
    if (s.perso !== 'none' && !O.isStitch(s.perso) && !s.persoText) throw new Error('Please add the text for your personalisation, or choose no personalisation.');
    if (O.isStitch(s.perso) && !s.persoText) throw new Error('Please add the letter for your hand-stitched monogram, or choose no personalisation.');
    if (O.isStitch(s.perso) && s.persoText.length > O.MONOGRAM_MAX) throw new Error('The hand-stitched monogram is a single letter.');
    if (s.perso === 'hotfoil' && s.persoText.length > O.FOIL_MAX) throw new Error('Hot foil text can be up to ' + O.FOIL_MAX + ' characters. Please shorten it in Preview & edit.');
    if (s.laceMode === 'lace' && !lz.k) throw new Error('Please choose your lace or doily, or select Nothing.');
    if (s.bookmark !== 'none' && !bmi) throw new Error('Please choose your bookmark, or select No bookmark.');
    if (s.perso !== 'none') props['Personalisation'] = this.persoLabel();
    if (lz.k) props['Lace & Doily'] = lz.name + ' — ' + lz.where;
    if (s.charm !== 'none') props['Keepsake Charm'] = CHARM_NAME[s.charm] + ' · ' + s.charmFamily.charAt(0).toUpperCase() + s.charmFamily.slice(1);
    if (bmi) props['Keepsake Bookmark'] = this.bmName(bmi) + ' (' + BM_FAM[bmi.fam].toLowerCase() + ', ' + BM_MAT[bmi.mat].toLowerCase() + ')';
    if (s.refills > 0) props['Extra refills'] = s.refills + ' × ' + n.insert;
    var items = [{ id: variant.id, quantity: 1, properties: props }];
    function addon(group, key, detail, forceTitle) {
      var title = forceTitle || ADDON_TITLE[group][key];
      var a = (shop.addons || []).filter(function (x) { return x.title === title; })[0];
      if (!a) throw new Error('The "' + title + '" detail cannot be ordered online yet. Please remove it or contact the atelier.');
      var p = { 'For journal': forLabel }; if (detail) p['Detail'] = detail;
      items.push({ id: a.id, quantity: 1, properties: p });
    }
    if (s.perso !== 'none') addon('perso', s.perso, props['Personalisation']);
    if (lz.k) addon('lace', s.lace, props['Lace & Doily'], lz.addon);
    if (s.charm !== 'none') addon('charm', s.charm, props['Keepsake Charm']);
    if (bmi) items.push({ id: bmi.id, quantity: 1, properties: { 'For journal': forLabel } });
    if (s.refills > 0) {
      var sz = sizeKey(P.sub);
      var r = (shop.refills || []).filter(function (x) { return x.paper === n.insert && x.size === sz; })[0];
      if (!r) throw new Error('Extra ' + n.insert.toLowerCase() + ' refills in ' + sz + ' cannot be ordered online yet.');
      items.push({ id: r.id, quantity: s.refills, properties: { 'For journal': forLabel } });
    }
    return items;
  };

  function init() {
    document.querySelectorAll('[data-ia-journal-builder]').forEach(function (root) {
      if (root.dataset.iaInited) return;
      root.dataset.iaInited = '1';
      new IrisJournalBuilder(root);
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
  document.addEventListener('shopify:section:load', init);
})();
